// 请保证所有语言包 的Key值都一直
export default {
  login: {
    username: '用户名',
    password: '密码',
    logOut: "退出重新登录",
    accessPermissions: '很抱歉，您没有访问产品配置器的权限',
    businessSupport: "业务支持",
    questionsContact: '如有疑问，请联系：',
    technicalSupport: '技术支持',
  },
  // 首页模块
  homePage: {
    whetherOut: '是否退出本系统?',
    cancelOut: '已取消退出',
    alternativeModels: '替代品型号',
    filter: '筛选条件',
    accordingProvider: '显示服务商专供',
    exportDefault: '默认导出字段',
    whetherOpen: '是否开启',
    productAutomaticMemory: '产品名称自动记忆',
    parameterAutomaticMemory: '参数自动记忆',
    viewDetails: '查看详情',
    quotationOnly: '报价单单号:',
    compile: '编辑',
    high: '高',
    toReplace: '去替换',
    operationRecords: '操作记录',
    anOperationRecords: '展开操作记录',
    closingOperationRecords: '关闭操作记录',
    operatingTime: '操作时间',
    operatingContent: '操作内容',
    quotation: '报价单',
    product: '产品',
    quotationSearch: '通过报价单名称、备注搜索',
    recommendation: '推荐使用谷歌、火狐、360极速、搜狗等非IE内核的浏览器。当提示网络异常或加载速度过慢时，请优先尝试刷新或清理缓存方法',
    productInquire: '产品查询',
    enterProductModel: '请输入产品型号',
    searchProductModel: '通过产品型号搜索',
    technicalSupport: '技术支持',
    supplyBusinessSupport: '供应风险业务支持',
    productLineContact: '产品线联系方式',
    operationalService: '服务政策的操作指南',
    operationGuide: '操作引导',
    yourAdvice: '您的建议',
    newAccurate: '新增的精准关联功能，您觉得体验如何？(即选择主机便可带出适配的配件)',
    configuratorOverall: '配置器整体使用体验如何?',
    otherSuggestions: '其他建议',
    pleaseEnterComments: '请输入您的意见',
    confirm: '确定',
    takeAway: '取消',
    submitTo: '提交',
    save: '保存',
    pleaseselectservicetype: '请选择服务类型',
    pleaseselectserviceduration: '请选择服务时长',
    addmaintenanceservice: '添加维保服务',
    lengthofservice: '服务时长（年）',
    servicetype: '服务类型',
    pleaseEnterContent: '请输入内容',
    search: '搜索',
    reset: '重置',
    advancedSearch: '高级搜索',
    clickProductLine: '点选产品线',
    clickProductCategories: '点选产品大类',
    clickProductSeries: '点选产品系列',
    accordingHost: '显示主机',
    accordingServiceProviders: '显示服务商',
    ruleWrongWantFeedback: '规则有误,我要反馈',
    productChangeThat: '产品变更说明',
    wantScore: '我要评分',
    contactUs: '联系我们',
    operatingInstructions: '操作指导说明',
    videoDirection: '视频引导',
    changeLog: '更新日志',
    personalSetting: '个人设置',
    userAuthorization: '用户授权',
    logOut: '退出登录',
    createQuotation: '创建报价单',
    managementQuotation: '管理报价单',
    myQuotation: '我的报价单',
    notClassified: '未分类',
    recycleBin: '回收站',
    myCreated: '我创建的',
    complianceStatus: '合规状态',
    myShareThe: '我分享的',
    createFolder: '创建子文件夹',
    modifyFolderSonName: '修改子文件夹名称',
    deleteFolder: '删除子文件夹',
    emptyRecycle: '清空回收站',
    sharedObject: '分享对象',
    sharingTime: '分享时间',
    checkTime: "查看记录",
    activate: "激活",
    productsPulledQuotation: '您的报价单中有产品已下架:',
    serviceProvidersQuotation: '您的报价单中有服务商专供产品:',
    shortagesProductsQuotation: '您的报价单中有供应紧缺的产品',
    currentProjectCycle: '当前项目备货周期为',
    DaysCRMSystem: '天，请提前在CRM系统上勾选备货',
    expectedEaseDate: '预计缓解日期',
    quantityDemanded: "需求数量",
    details: '详情',
    productModel: "产品型号",
    stockCycle: '备货周期',
    status: "状态",
    alternativeProductModel: '替代产品型号',
    projectName: '项目名称',
    businessCode: " 业务机会编码:",
    exportSales: ' 外销:',
    saleTechnicalSupport: '售前技术支持:',
    specifyPeopleShare: '指定人分享:',
    pleaseEnterDesignatedShare: '请输入指定分享人',
    name: '姓名',
    department: '部门',
    notHave: '无',
    channelType: '渠道类型',
    customizeWizard: '自定义文件夹',
    selectDiscountRefresh: '请选择折扣价刷新方式',
    newFolder: '新增文件夹',
    modifyFolderName: '修改文件夹名称',
    pleaseFillPerson: '请填写指定人',
    shareSuccess: '分享成功',
    notAvailable: '暂无',
    permissionsProducts: '产品的查看权限,',
    pleaseModifyShare: ',请修改报价产品清单后再分享。',
    failureReasons: '失败原因',
    userNoCRMInformation: '该用户暂无CRM项目信息',
    deleteProjectContinue: "删除报价单项目，是否继续？",
    prompt: '提示',
    deletedSuccessFully: "删除成功!",
    deleteProjectFailure: "删除报价单项目失败，请联系管理员！",
    copyQuotationProject: '复制报价单项目，是否继续？',
    copySuccess: '复制成功!',
    copyProjectFailureError: "复制报价单项目失败，请联系管理员！",
    hasBeenActivated: '已激活,可在首页第一条可进行编辑使用？',
    activateSuccess: "激活成功！",
    activateError: "激活失败，请联系内部开发人员！",
    refreshPrice: "是否刷新价格？",
    modifyFailureError: "修改失败!",
    pleaseSelectFolder: '请选择文件夹',
    newFolderLevel: '新增文件夹深度最大支持2级',
    onlyCreateFolder: '只允许在我的报价单文件夹下创建子文件夹',
    onlyDeleteFolder: '只允许删除我的报价单下创建的子文件夹',
    deleteFoldersConfirm: '删除文件夹后，文件夹里的报价单将全部进入回收站，请确认是否继续？',
    deleteFailureAdministrator: '删除报价单项目失败，请联系管理员！',
    confirmRecycleBin: '是否确认清空回收站？',
    emptyRecycleSuccess: '清空回收站成功！',
    emptyRecycleFailure: '清空回收站失败，请联系内部开发人员！',
    errorGettingUser: '获取用户文件夹分类错误',
    newFolderSuccess: '新增文件夹成功',
    newFolderRepeated: '新增文件夹名称不可空且不可以重复',
    modifyTheFolderName: '修改文件夹名称成功',
    modifyFolderNotRepeated: '修改文件夹名称不可空且不可以重复',
    moveQuotationSuccess: '移动报价单成功',
    mobileQuotationFailure: '移动报价单失败',
    verySolutionGuide: '极简光方案弱电箱购买指南',
    projectMinimalistPrompt: ' 1. 项目极简光交换机部署在弱电箱场景，建议采购下面指定弱电箱。采用指定弱电箱（经过我司测试），壳温只会比室温环境高10℃，同时有安装拆卸的零部件设计；注意：市面上开孔率不达标，会造成设备壳温高。',
    weakProvidingFollowingModels: ' 2. 弱电箱采购采用和第三方供应商合作的方式，提供以下款型：',
    TheRules: '规则',
    size: '尺寸',
    priceTax: '价格（含税，不含税可减13%）',
    builtWeakCurrent: '内嵌式弱电箱（包含基座+门板），含插排，不含熔纤盒（可加购）',
    embeddedBoxPlank: '内嵌式弱电箱门板（仅包含门板）',
    wallHungLowBox: '壁挂式弱电箱（包含基座+门板），含插排，不含熔纤盒（可加购）',
    orderChannel: '3. 下单渠道：联系人王经理:',
    alibabaPurchaseLink: '阿里巴巴采购链接：',
    notePrice: '注意：开票需要备注，默认不开票。含税不含税价格有差',
    orderPurchaseDays: '4. 下单采购请采用现金全额转账，付款后14天到货。',
    networkAnomaly: '网络异常',
    moveTheTo: '移动到',
    shareWithMe: '分享给我的',
    theNameList: '报价单名称',
    directoryTotalPrice: '目录总价（元）',
    lastModified: '最后修改日期',
    source: '来源',
    shareRecord: '分享记录',
    operate: '操作',
    modify: '修改',
    delete: '删除',
    copy: '复制',
    remarks: '备注',
    export: '导出',
    share: '分享',
    moveTo: '移动',
    theRefreshPrice: '刷新价格',
    page: '页',
    article: '条',
    leaveFor: '前往'
  },
  // 导出模块
  exportExcelModule: {
    myQuotation: '我的报价单',
    exportTheShare: '导出&分享',
    exportExcel: '导出excel',
    exportFieldScreening: '导出字段筛选',
    exportField: '导出字段:',
    exportFormat: '导出格式',
    productSeries: '产品系列',
    productName: '产品名称',
    productModel: '产品型号',
    productDes: '产品描述',
    directoryPrice: '目录单价',
    totalNumber: '总数量',
    catalogPrice: '目录总价',
    subtotalConfigurationGroup: '带配置组小计',
    withListTotal: '带整单总计',
    withSderviceSet: '带服务配置组',
    coverWithExcel: '带Excel封面',
    continueExport: '继续导出',
    downloadSOW: '下载SOW',
    keepStaring: '继续导出',
  },
  //  创建报价单模块
  createQuotation: {
    sellsArea: '销往地区',
    enterRegionName: '请输入销往地区名称',
    totalPriceAfterDiscount: '折后总价:',
    pleaseDiscountValue: '请输入折扣值',
    applicationGuideDiscount: '应用指导折扣',
    configurationSet: '配置组',
    guideDiscount: '指导折扣',
    theDiscountValue: ' 折扣值（%）',
    subtotal: '小计',
    discountOnlyNumbers: '折扣率只能输入数字，且小数位不能超过2位',
    discountCannotHigher: '折扣率不能高于100%',
    discountCannotNegative: '折扣率不能为负数',
    discountSuccessfully: '折扣计算成功',
    discountCalculatedFailure: '折扣计算失败',
    discountCalculationSaveFailed: '折扣计算保存失败',
    share: '分享',
    shareFailure: '失败。原因：',
    wordText: '字',
    pleaseNameQuotation: '请输入报价单的名称',
    lengthExceedCharacters: '长度不得超过200个字符',
    networkAnomaly: '网络异常',
    addServiceConfigurationGroup: '添加服务配置组',
    sceneChange: '场景化',
    modifyProgram: '修改方案',
    modifyProduct: '修改产品',
    delete: '删除',
    copy: '复制',
    addProduct: '添加产品',
    operation: '操作',
    previousStepBasicInformation: '上一步，项目基本信息',
    nextProductDiscounts: '下一步，填写产品折扣',
    addConfigurationSet: '添加配置组',
    enterGroupName: '请输入配置组名称',
    cancel: '取消',
    add: '添加',
    moreCharacters: '不能超过40个字符',
    addGroupSuccess: '添加配置组成功!',
    sortModifySuccess: '修改排序成功!',
    confirm: '确定',
    takeAway: '取消',
    deleteSucceeded: '删除成功',
    deleteErrorMessage: '删除失败，请联系管理员！',
    copyErrorMessage: '复制失败,请联系管理员!',
    editGroupNameSuccess: '修改配置组名称成功！',
    myQuotation: '我的报价单',
    projectBasicInformation: '项目基本信息',
    productConfigurationList: '产品配置清单',
    discountInformation: '折扣信息',
    exportShare: '导出分享',
    theNameList: '报价单名称:',
    EcpProjectRelated: 'ECP项目关联',
    customerName: '客户名称:',
    pleaseInputClientName: '请输入客户名称',
    fileNameFolder: '文件夹名称:',
    quotationNote: '报价单备注:',
    belongGroup: '所属事业部',
    cancelledReturnMyQuotation: '取消创建，返回我的报价单',
    nextConfigureProductList: '下一步,配置产品清单',
    pleaseEnterNameList: '请输入报价单名称',
    pleaseEnterECPProjectName: '请输入ECP系统对应项目名称',
    pleaseEnterNoteInformation: '请输入备注信息',
    pleaseEnterTheContent: '请输入内容',
    catalogPrice: '目录总价',
    modifyConfigurationGroupName: '修改配置组名称',
    configurationGroupName: '配置组名称:',
    sequenceShows: '反序显示',
    configurationSetType: '配置组类型',
    creationDate: '创建日期',
    thisOperationCopyContinue: '此操作将会复制该配置组所有信息，是否继续？',
    cancelledCopy: '已取消复制',
    thisPermanentlyDeleteContinue: '此操作将永久删除该配置组信息，是否继续？',
    hasBeenDelete: '已取消删除',
    drag: '拖动',
    addSolution: '添加解决方案',
    addGeneralConfigurationGroup: '添加常规配置组',
    conventional: '常规',
    service: '服务',
    discountPrice: '折扣总价',
    wholeSingleDiscount: '整单折扣:',
    setDiscountValue: '设置折扣值（%）:',
    editConfigurationGroup: '配置组',
    configurationSeries: '配置系列',
    pleaseEnterDiscount: '请输入折扣',
    application: '应用',
    reset: '重置',
    productSeries: '产品系列',
    productName: '产品名称',
    productModel: '产品型号',
    discountValue: '折扣值',
    directoryPrice: '目录单价(元)',
    serviceUnitPrice: '服务商单价(元)',
    salesUnitPrice: '促销单价（元）',
    afterFoldingUnitPrice: '折后单价（元）',
    totalNumber: '总数量',
    totalQuantity: '保存',
    stepConfigurationList: '上一步，配置产品清单',
    nextStep: '下一步，导出&分享',
    exportQuotation: '导出报价单',
    shareQuotation: '分享报价单',
    returnQuotationList: '返回报价单列表',
    createNewQuotation: '创建新报价单',
    prompt: '提示',
    copyQuotationContinue: '复制报价单项目，是否继续？',
    exportTheShare: '导出&分享',
    quotationPromptInformation: '报价单提示信息',
    crmSystemDate: '当前项目备货周期为120天，请提前在CRM系统上勾选备货。',
    continueExport: '继续导出',
    exportFieldScreening: '导出字段筛选',
    straussClickViewDetails: '如若项目极简光交换机部署在弱电箱场景，必须采购后面详情指定弱电箱，请点击查看,详情',
    shortagesQuotation: '您的报价单中有供应紧缺的产品',
    quotationDeliStingProducts: '您的报价单中有退市的产品：',
    canReplaceQuotation: '您的报价单中有可以替换的产品：',
    ECPProjectsShare: 'ECP项目分享:',
    designatedShare: '指定分享人',
    deleteWhetherContinue: '删除报价单项目,是否继续?',
    moveFolder: '移动到文件夹',
    theRefreshPrice: '刷新价格',
    pleaseDiscountPrice: '请选择折扣价格刷新方式',
    discountSame: '折扣不变',
    discountedUnchanged: '折后价格不变'
  },
  // 添加配置组模块
  addConfigModule: {
    rulesMessage: '请输入配置组名称',
    rulesNumberMessage: '不能超过40个字符',
    packageRulesName: '请输入产品组合名称',
    specialCharacters: '填写内容请勿带有特殊字符',
    myQuotation: '我的报价单',
    productConfigurationGroup: '产品配置组',
    addProduct: '添加产品',
    productAdded: '已添加产品',
    search: '搜索',
    reset: '重置',
    close: '关闭',
    productModel: '产品型号',
    noMore: '没有更多',
    clickProductLine: '点选产品线',
    clickProductCategories: '点选产品大类',
    clickProductSeries: '点选产品系列',
    productCategory: '产品大类',
    productLine: '产品线',
    productRange: '产品系列',
    deploymentConfiguration: '展开配置',
    editConfigurationGroup: '编辑配置组',
    pleaseEnterTheContent: '请输入内容',
    determine: '确定',
    preListingTime: '预上市时间',
    marketRetailPrice: '市场零售价格',
    productDescription: '产品说明',
    networkAnomaly: '网络异常',
    enterGroupName: '请输入配置组名称',
    cannotExceedCharacters: '不能超过40个字符',
    editGroupNameSuccess: '修改配置组名称成功！',
    addGroupNameSuccess: '添加至配置组成功！',
    changeNotProduct: '您没有选择任何产品！',
    expandOrCloseAll: '全部展开或关闭',
    productName: '产品名称',
    productDes: '产品描述',
    enterProductName: '请输入产品名称',
    editProductNameSuccess: '产品名称更改成功！',
    QueryProductModelOrDescription: '查询包含的产品型号或描述',
    day: '天',
    yuan: '元',
    zhi: '至',
    wu: '无',
    promotionPrice: '促销价格',
    promotionTime: '促销时间',
    serviceProviderPrice: '服务商价格',
    batchProduction: '量产',
    remainingInventoryClearing: '剩余库存清理',
    stopPlacingAnOrder: '停止下单',
    reportingLock: '报备锁定',
    productConfigRelationshipReminder: '产品配置关系提醒',
    continueSavingChanges: '继续保存修改',
    continueSavingClose: '继续保存并关闭',
    collectionOfProductsSucceeded: '收藏产品成功！',
    cancelFavoriteProductsSuccessfully: '取消收藏产品成功！',
    accordingProductClassification: '根据产品线加载分类',
    hideComboPackage: '隐藏组合包', //  第二批翻译,丢失的字段
    myCollection: '我收藏的单品', //  第二批翻译,丢失的字段
    cancelFavoriteProduct: '确认取消收藏的产品么？', //  第二批翻译,丢失的字段
    prompt: '提示',
    cancelCollectionSuccessfully: '取消收藏成功!', // 第二批翻译,丢失的字段
    failedCancelCollectionContactAdmin: '取消收藏失败，请联系管理员！',
    productTips: '产品提示信息',
    productsAddedChangedPleaseReCollect: '您添加的产品中有产品发生变更请重新收藏',
    myFavoritePortfolio: '我收藏的产品组合',
    searchPortfolioName: '通过产品组合名称搜索',
    assortmentName: '产品组合名称',
    discountFont: '描述文字',
    price: '价格',
    editSingleProductNumSuccessfully: '修改单品数量成功！',
    editSingleProductNumFaild: '修改单品数量失败！',
    deleteProductsMsg: '此操作将永久删除该系列及所选产品，是否继续？',
    hasBeenDelete: '已取消删除',
    deletedCombinedProductSuccessfully: '删除组合产品成功！',
    deletedCombinedProductFail: '删除组合产品失败！',
    editCombinedProductNameSuccessfully: '修改组合产品名称成功！',
    editCombinedProductNameFail: '修改组合产品名称失败！',
    editCombinedProductNameFailMsg: '更改组合产品名称失败，名称不能重复！',
    preciseCorrelation: '精准关联',
    fuzzySearch: '模糊搜索',
    save: '保存',
    deconfigure: '去配置',
    deleteSucceeded: '删除成功',
    saveSucceeded: '保存成功',
    deleteSelecedProductsMsg: '此操作将永久删除所选产品，是否继续？',
    deleteSelecedXlAndProductsMsg: '此操作将永久删除选中的系列及所选产品，是否继续？',
    addConfigurationSet: '添加配置组',
    configurationGroupName: '配置组名称',
    cancel: '取消',
    add: '添加',
    fuzzyClickHost: '模糊点选主机',
    searchProductModel: '通过产品型号、描述搜索',
    hideDeliSting: '隐藏退市',
    hiddenFor: '隐藏专供',
    hideLightModule: '隐藏光模块',
    accordingHost: '显示主机',
    hostLightModule: '主机+光模块',
    accordingServiceProviders: '显示服务商',
    myFavorite: '我的收藏',
    addProductConfigureGroup: '添加产品至配置组',
    priceRMB: ' 价格(元)',
    theNumber: '数量',
    operation: '操作',
    status: '状态',
    periodAfterPreparationTime: '周期、下单后准备时间',
    leadTime: '备货周期',
    orderPreparationTime: '下单后准备时间',
    Represents: '',
    Represents1: '1、有预测报备前提下的生产备货周期。起点：提交产品报备的时间   终点：标品产出的时间；',
    Represents2: '2、产品齐套时间=备货周期+下单后准备时间，物流时间需根据实际情况另行测算；',
    Represents3: '3、如存在单批次要货数量超大的情况，备货周期可能会相应延长，具体请咨询锐捷销售或市场计划；',
    Represents4: '4、如为新品、退市、预退市的产品，备货周期请咨询说捷销售或市场计划。',
    orderPreparation: '产品提前报备并且报备周期足够的前提下订单被最终确认到货品齐套的时间。',
    // 服务产品线Tips提示配置
    serviceProductTispTtile: `根据产品交付的难度和风险将产品分为A、B1、B、C和D类。`,
    serviceProductTispContent1: `A类产品:安装和配置困难且有风险,高端新品、新解决方案或复杂解决方案。
    `,
    serviceProductTispContent2: `B1类产品:难以安装和配置的高端产品或技术复杂的解决方案。
    `,
    serviceProductTispContent3: `B类产品:安装和配置难度适中,风险较低,属于中高端产品。
    `,
    serviceProductTispContent4: `C类产品:易于安装和配置且无风险的中低端产品。
    `,
    serviceProductTispContent5: `D类产品:易于安装和配置的终端产品。

    `,
    // ---end
    serviceClassification: '服务分类',
    specialInstructions: '特殊说明',
    alternativeModels: '替代型号',
    more: '更多',
    collectionOperation: '收藏操作',
    loadMore: '加载更多',
    productModelOrQueryContains: '查询包含的产品型号或描述',
    numberOf: '套数',
    saveChanges: '保存修改',
    saveClose: '保存并关闭',
    selectAll: '全选',
    delete: '删除',
    copy: '复制',
    amount: '数量总计',
    serviceConsultTube: '服务产品折扣申请请咨询销管',
    quantitySet: '数量/套',
    unit: '单位',
    type: '类型',
    powerConsumption: '功耗(W)',
    replaceModel: '替换型号',
    parameter: '参数'
  },
  //已添加产品
  productAdded: {
    jumpRemind: '产品配置关系提醒',
    continueJump: '继续跳转',
    myQuotation: '我的报价单',
    productConfigurationGroup: '产品配置组',
    addProduct: '添加产品',
    productAdded: '已添加产品',
    selectAll: '全选',
    delete: '删除',
    copy: '复制',
    collectionProduction: '收藏产品组合',
    configurationGroupName: '配置组名称',
    priceRMB: ' 价格(元)',
    amount: '数量总计',
    serviceConsultTube: '服务产品折扣申请请咨询销管',
    myFavorite: '我的收藏',
    back: '返回',
    save: '保存',
    productName: '产品名称',
    productModel: '产品型号',
    productDes: '产品描述',
    expandOrCloseAll: '全部展开或关闭',
    quantitySet: '数量/套',
    unit: '单位',
    serviceClassification: '服务分类',
    status: '状态',
    serviceConfiguration: '服务配置',
    batchSelectionService: '批量选配置',
    type: '类型',
    specialInstructions: '特殊说明',
    powerConsumption: '功耗(W)',
    replaceModel: '替换型号',
    remarks: '备注',
    parameter: '参数',
    operate: '操作',
    noteInformation: '备注信息',
    pleaseEnterNoteInformation: '请输入备注信息',
    pleaseCheckFavorite: '请勾选要收藏的产品组合',
    oncePowerConsumption: '单套功耗(W)',
    numberOf: '套数',
    discountFont: '描述文字',
    eploymentConfiguration: '展开配置',
    clickRemove: '点击拖动',
    parameterMessage: '参数信息',
    inputParameterMessage: '请输入参数信息',
    check: '查看',
    replace: '替换',
    remove: '拖动',
    message_001: '此操作将永久删除该系列及所选产品，是否继续？',
    prompt: '提示',
    message_003: '确定替换产品吗？(如果是主机将会清空配件)',
    message_004: '确认要复制该系列么，复制出的系列将出现在最下方，是否继续？',
    message_005: '确认要复制么，复制出的内容将出现在最下方，是否继续',
    message_006: '确认取消全部原厂实施么？',
    message_007: '确认全部原厂实施么？',
    message_008: '收藏的产品组合每次只能选择一个系列',
    message_009: '确定替换产品吗？',
    selectVolumeService: '请选择相同的服务套餐产品进行配置！',
    configureDragBox: '配置组排序拖动框',
    networkAnomaly: '网络异常',
    saveSucceeded: '保存成功',
    replaceSucceeded: '替换成功',
    saveFail: '自动保存失败',
    copyFail: '复制失败',
    hasBeenDelete: '已取消删除',
    nameUpdateSucceeded: '产品名称更改成功！',
    addProductSucceeded: '新增产品组合包成功',
    deleteSucceeded: '删除成功',
    // qualificationsName:'资质名称',
    // qualificationsType:'资质类型',
    // qualificationsAuthentication:'资质认证',
    dateIssue: '颁证日期', // 第二批翻译, 丢失的字段
    expiryDate: '失效日期',  // 第二批翻译, 丢失的字段
    replaceProduct: '替换产品',
    needReplaceProduct: '要替换的产品型号:',
    enterProductModel: '请输入产品型号',
    otherHost: '其他系列主机',
    select: '查询',
    tryMyBestLoading: '拼命加载中',
    productState: '产品状态',
    typAndProjectCycle: '类型，备货周期',
    updateSuccess: '修改成功',
    updateFail: '修改失败',
    saveFailed: '保存失败',
    addProductTogether: '添加产品组合',
    togetherName: '产品组合名称：',
    pleaseEnterTheContent: '请输入内容',
    teamName: '小组名称',
    editConfigurationGroup: '编辑配置组',
    service: '服务配置'
  },
  // 我的收藏模块
  myCollection: {
    accordingProductClassification: '根据产品线加载分类',
    search: '搜索',
    reset: '重置',
    close: '关闭',
    searchProductModel: '通过产品型号、描述搜索',
    searchPortfolioName: '通过产品组合名称搜索'
  },
  // 出口合规检测模块（合规要求：统一英文展示）
  exportCompliance: {
    dialogTitle: 'Export Compliance Risk Alert / Block',
    cancel: 'Cancel',
    confirm: 'Confirm',
    continue: 'Continue',
    submitReview: 'Submit Review',
    reviewPending: 'A review has already been submitted and is being processed. Please wait for the result.',
    reviewSubmitted: 'The review request has been submitted successfully.',
    reviewSubmitFailed: 'Failed to submit the review request. Please try again.',
    reviewRejected: 'The review was not approved. You may submit a new review request.',
    systemError: 'The export compliance detection service is temporarily unavailable. You may continue or cancel.',
    refreshSuccess: 'Review status refreshed.',
    refreshFailed: 'Failed to refresh review status. Please try again.',
    statusPending: 'Pending Review',
    statusPassed: 'Review Approved',
    statusRejected: 'Review Not Approved',
    releaseFailed: 'Failed to record the manual release. Please try again.'
  }
};
